import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {NgClass} from "@angular/common";
import {IterableUtil} from "@shared/util/collections/collection-utils";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {I18nMessage} from "@shared/api/model/i18n";
import {AppIconSize} from "@shared/components/icon/icon.component";


export type ButtonVisual = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'muted' | 'link';
export type ButtonSize = 'sm' | 'lg';


@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  standalone: false
})
export class ButtonComponent implements OnChanges {

  private readonly ngClassFactors: (keyof ButtonComponent)[] = ['size', 'visual', 'outlined', 'buttonClass', 'buttonNgClass', 'disabled'];

  @Input() type: 'submit' | 'button' = 'button';
  @Input() size: ButtonSize;
  @Input() loading = false;
  @Input() disabled = false;
  @Input() outlined = false;
  @Input() routerLink: any[] | string;
  @Input() visual: ButtonVisual;

  @Input() buttonClass: string;
  @Input() buttonNgClass: NgClass['ngClass'];

  @Input() label: string | I18nMessage;
  @Input() labelString: string;

  @Input() faIcon: IconProp;
  @Input() appIcon: string;
  @Input() appIconSize: AppIconSize;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  protected ngClass: NgClass['ngClass'];

  ngOnChanges(changes: SimpleChanges) {
    if (this.ngClassFactors.some(factor => changes[factor])) {
      this.ngClass = this.buildButtonNgClass();
    }
    if (changes.faIcon || changes.appIcon) {
      if (this.faIcon && this.appIcon) {
        throw new Error('faIcon and appIcon cannot both be set at the same time.')
      }
    }
    if (changes.label || changes.labelString) {
      if (this.label && this.labelString) {
        throw new Error('label and labelString cannot both be set at the same time.')
      }
    }
  }

  onClick(event: MouseEvent): void {
    this.buttonClick.emit(event);
  }

  private buildButtonNgClass(): NgClass['ngClass'] {
    const ngClass: NgClass['ngClass'] = {};
    if (this.outlined || this.visual) {
      const visualClassName = 'btn'
        + (this.outlined ? '-outline' : '')
        + ('-' + (this.visual ?? 'primary'));
      ngClass[visualClassName] = true;
    }
    if (this.size) {
      ngClass['btn-' + this.size] = true;
    }
    if (this.buttonNgClass) {
      if (typeof this.buttonNgClass === 'string') {
        ngClass[this.buttonNgClass] = true;
      } else if (IterableUtil.isIterable(this.buttonNgClass)) {
        IterableUtil.map(this.buttonNgClass, className => ngClass[className] = true);
      } else {
        Object.assign(ngClass, this.buttonNgClass);
      }
    }
    return ngClass;
  }

}
